module.exports = __webpack_public_path__ + "img/K.efbcb9b1.jpg";